export default {
  free_menu_items: 'Deblocat gratuit',
  discount_badge: '{{value}} reducere',
  available_at_badge: 'Disponibil {{schedule}}',
  restricted_tooltip: 'Disponibil {{schedule}} — modifică ora de ridicare de mai sus pentru a comanda.',
};
